import type { SvgIconProps } from "./SVGIcon";
import SvgIcon from "./SVGIcon";

export default function IconPhasePlanPrep(props: SvgIconProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="6" r="6" fill="#D6D6D6" />
      <path
        d="M6 0C7.05321 1.25594e-08 8.08786 0.277232 8.99997 0.803832C9.91208 1.33043 10.6695 2.08785 11.1961 2.99995C11.7227 3.91205 12 4.9467 12 5.99991C12 7.05312 11.7228 8.08777 11.1962 8.99989L6 6V0Z"
        fill="#616161"
      />
    </SvgIcon>
  );
}
